if (!(window as any).CM) (window as any).CM = {};
const CM = (window as any).CM;
if (!CM.ux) CM.ux = {};

if (!CM.ux.userDropdown) {
    CM.ux.userDropdown = {
        intialize: () => {
            $('#userButton').click(CM.ux.userDropdown.show);
            $('.lang').click(function (ev) {
                ev.preventDefault();
                const language = $(this).attr('href');
                CM.tool.page.changeLanguage(language);
            });
        },
        show: (e) => {
            $('#userButton').addClass('active');
            $('#userDropdown').slideDown();
            e.stopPropagation();
            $('body').click(CM.ux.userDropdown.hide);
        },
        hide: () => {
            $('#userButton').removeClass('active');
            $('#userDropdown').slideUp(200);
        },
    };
}
